module.exports = __webpack_public_path__ + "static/media/vr-coding-ted-talk.fc2b7113.webp";